import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { TableRowsLoader } from '../../components/styledComponent/table/TableLoader';
import { endpoints } from '../../api/endpoints';
import { TableHeadCell } from '../../components/styledComponent/table/TableCell';
import { Box, Chip, Grid, Paper, Tooltip, Typography } from '@mui/material';
import { TablePagination } from '../../components/pagination/Pagination';
import { LoadingButton } from '@mui/lab';
import { ControlledInput } from '../../components/forms/input/ControlledInput';
import { useForm } from 'react-hook-form';
import { useEffect, useState } from 'react';
import { Search } from '@mui/icons-material';
import CustomSelect from '../../components/forms/select/CustomSelect';
import { useCrudForm } from '../../api/useCrudForm';
import { getStatusColor } from '../customer/form/DetailsForm';
import SingleInputDateRangePicker from '../../components/dateRange/DateRange';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import * as XLSX from 'xlsx';

export default function LockerListReport() {

    const [lockerList, setLockerList] = useState<any | null>()
    const [lockerStatusList, setLockerStatusList] = useState<any | null>()
    const [lockerTypeList, setLockerTypeList] = useState<any | null>()
    const [lockerLocationList, setLockerLocationList] = useState<any | null>()
    const [loading, setLoading] = useState<boolean>(false);
    const [buttonLoading, setButtonLoading] = useState<boolean>(false);
    const [exportLoading, setExportLoading] = useState<boolean>(false);
    const [skip, setSkip] = useState(0)
    const [count, setCount] = useState<any>(0);
    const [take, setTake] = useState(10)
    const [showApproved,] = useState<string>('true');

    const { get } = useCrudForm();

    const refetchData = ({ lockerNo, lockerType, lockerLocation, lockerStatus, isMainTable }: { lockerNo?: any, lockerType?: any, lockerLocation?: any, lockerStatus?: any, isMainTable?: any }) => {
        setLoading(true)
        get({
            endpoints: endpoints.locker.list({ lockerNo, skip: skip * take, take, lockerType, lockerLocation, lockerStatus, isMainTable }),
            onSuccess: (data: any) => {
                setLockerList(data.data.list)
                setCount(data.data.count)
                setLoading(false)
                setButtonLoading(false)
            },
            onError: (error: any) => {
                console.log(error)
                setLoading(false)
                setButtonLoading(false)
            }
        })
    }

    const initialValues = { lockerType: 0, lockerNo: '', lockerLocation: 0, lockerStatus: '', fromDate: null, toDate: null }

    const { handleSubmit, control, formState: { errors, }, setValue, getValues } = useForm({
        defaultValues: initialValues
    })

    const handleSearchButtonClick = (values: any) => {
        setSkip(0)
        setTake(take)
        setButtonLoading(true)
        refetchData({ lockerNo: values?.lockerNo, lockerType: values?.lockerType, lockerLocation: values?.lockerLocation, lockerStatus: values?.lockerStatus, isMainTable: showApproved })
    };

    const resetSearch = () => {
        setValue("lockerType", 0);
        setValue("lockerNo", '');
        setValue("lockerLocation", 0);
        setValue("lockerStatus", '');
        setValue("toDate", null);
        setValue("fromDate", null);
        setLoading(true)
        refetchData({ isMainTable: showApproved })
    };

    const getFilterSelectData = () => {
        get({
            endpoints: endpoints.common.getLockerStatus,
            onSuccess: (data: any) => {
                setLockerStatusList(data.data)
            },
            onError: (error: any) => {
                console.log(error)
            }
        })
        get({
            endpoints: endpoints.common.getLockerTypes,
            onSuccess: (data: any) => {
                setLockerTypeList(data.data)
            },
            onError: (error: any) => {
                console.log(error)
            }
        })
        get({
            endpoints: endpoints.common.getLocations(),
            onSuccess: (data: any) => {
                setLockerLocationList(data.data)
            },
            onError: (error: any) => {
                console.log(error)
            }
        })
    }

    useEffect(() => {
        setLoading(true)
        getFilterSelectData()
        refetchData({ lockerNo: getValues()?.lockerNo, lockerType: getValues()?.lockerType, lockerLocation: getValues()?.lockerLocation, lockerStatus: getValues()?.lockerStatus, isMainTable: showApproved })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [skip, take])


    const handleDownload = () => {
        setExportLoading(true)
        get({
            endpoints: endpoints.locker.list({
                fromDate: getValues()?.fromDate,
                isExport: true,
                toDate: getValues()?.toDate,
                lockerNo: getValues()?.lockerNo,
                lockerType: getValues()?.lockerType,
                lockerLocation: getValues()?.lockerLocation,
                lockerStatus: getValues()?.lockerStatus,
                isMainTable: showApproved
            }),
            onSuccess: (data: any) => {
                const excelData = data.data?.list && data.data?.list.length > 0 ? data.data?.list.map((cus: any, index: number) => [
                    index + 1,
                    cus?.lockerNumber,
                    cus?.lockerType,
                    cus?.branchName,
                    cus?.locationName,
                    cus?.isApproved ? 'yes' : 'No',
                    cus?.lockerStatus
                ]) : []
                const headers = ["S.N", "Locker Number", "Locker Type", "Branch", "Locker Location", "Is Apporoved", "Locker Status"]
                const workbook = XLSX.utils.book_new();
                const worksheet = XLSX.utils.json_to_sheet(excelData);
                worksheet['!cols'] = [
                    { wch: 5 },
                    { wch: 10 },
                    { wch: 10 },
                    { wch: 20 },
                    { wch: 18 },
                    { wch: 10 },
                    { wch: 10 },
                ];
                XLSX.utils.book_append_sheet(workbook, worksheet, "Lockers");
                XLSX.utils.sheet_add_aoa(worksheet, [headers]);
                // const name = showApproved === 'true' ? 'ApprovedCustomerList.xlsx' : 'NeedToApprovedCustomerList.xlsx'
                XLSX.writeFile(workbook, 'lockers.xlsx', { compression: true });
                setExportLoading(false)
            },
            onError: (error: any) => setExportLoading(false)
        })
    };

    return (<Box sx={{ width: "100%", padding: "24px 12px", background: "white", borderRadius: "5px" }} my={2}>
        <Typography sx={{ color: 'gray', fontSize: '13px', marginBottom: '12px' }}>Search Locker</Typography>
        <form>
            <Grid container spacing={2} style={{ display: 'flex', justifyContent: 'start', marginBottom: "24px" }}>
                <Grid item xs={2} >
                    <ControlledInput name="lockerNo" control={control} errors={errors} label="Locker number" size={'small'} />
                </Grid>
                <Grid item xs={2} >
                    <CustomSelect height='2.5rem' label="Locker Type" name="lockerType" errors={errors?.lockerType?.message} control={control} values={lockerTypeList ?? []} size={12} setValue={setValue} />
                </Grid>
                <Grid item xs={2}>
                    <CustomSelect height='2.5rem' label="Locker Location" name="lockerLocation" errors={errors?.lockerLocation?.message} control={control} values={lockerLocationList ?? []} size={12} setValue={setValue} />
                </Grid>
                <Grid item xs={2} >
                    <CustomSelect height='2.5rem' label="Locker Status" name="lockerStatus" errors={errors?.lockerStatus?.message} control={control} values={lockerStatusList ?? []} size={12} setValue={setValue} isEnum={true} />
                </Grid>
                <SingleInputDateRangePicker control={control} errors={errors} setValue={setValue} getValues={getValues} />
                <Grid item xs={12} style={{ display: 'flex', justifyContent: 'right' }}>
                    <LoadingButton loading={buttonLoading} onClick={() => resetSearch()} variant="contained" sx={{ padding: '4px 8px', backgroundColor: '#3150A1', '&:hover': { backgroundColor: '#3150A1' } }} >Reset</LoadingButton>
                    <LoadingButton type='submit' loading={buttonLoading} onClick={(e) => { e.preventDefault(); handleSubmit(handleSearchButtonClick)() }} variant="contained" sx={{ marginLeft: '16px', backgroundColor: '#3150A1', '&:hover': { backgroundColor: '#3150A1' } }} ><Search /></LoadingButton>
                    <LoadingButton loading={exportLoading} onClick={() => handleDownload()} variant="contained" sx={{ padding: '4px 8px', backgroundColor: '#3150A1', marginLeft: '16px', '&:hover': { backgroundColor: '#3150A1', } }}>
                        <CloudDownloadIcon />
                        <Typography style={{ fontSize: '14px', marginLeft: '4px' }}>Export</Typography>
                    </LoadingButton>
                </Grid>
            </Grid>
        </form>

        <Paper sx={{ width: '100%', overflow: 'hidden' }}>
            <TableContainer sx={{ maxHeight: 460 }}>
                <Table stickyHeader aria-label="sticky table">
                    <TableHead>
                        <TableRow>
                            <TableHeadCell>S.N</TableHeadCell>
                            <TableHeadCell align="left" minwidth={"120px"}>Locker Number</TableHeadCell>
                            <TableHeadCell align="left" minwidth={"120px"}>Locker Type</TableHeadCell>
                            <TableHeadCell align="left" minwidth={"120px"}>Branch</TableHeadCell>
                            <TableHeadCell align="left" minwidth={"120px"}>Locker Location</TableHeadCell>
                            <TableHeadCell align="left" minwidth={"120px"}>Is Approved?</TableHeadCell>
                            <TableHeadCell align="left">Status</TableHeadCell>

                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {!lockerList || loading ? <TableRowsLoader rowsNum={5} colNum={7} />
                            : lockerList?.length <= 0 ? <TableRow>
                                <TableCell colSpan={7} align='center'>No Data Found</TableCell>
                            </TableRow>
                                : lockerList.map((row: any, index: number) => (
                                    <Tooltip sx={{ backgroundColor: '#121212' }} title={
                                        <Box>
                                            <Box sx={{ display: "flex", gap: "10px", justifyContent: 'start', alignItems: 'center' }}>
                                                <Box height="10px" width="10px" sx={{ backgroundColor: '#3150A1', padding: '6px' }}>
                                                </Box>
                                                <Typography style={{ fontSize: "12px", fontWeight: "600" }}>Created By: {row?.createdUser ?? "N/A"}</Typography>
                                            </Box>
                                            <Box sx={{ display: "flex", gap: "10px", justifyContent: 'start', alignItems: 'center' }}>
                                                <Box height="10px" width="10px" sx={{ backgroundColor: '#f1c40f', padding: '6px' }}>
                                                </Box>
                                                <Typography style={{ fontSize: "12px", fontWeight: "600" }}>Updated By: {row?.updatedUser ?? "N/A"}</Typography>
                                            </Box>
                                            <Box sx={{ display: "flex", gap: "10px", justifyContent: 'start', alignItems: 'center' }}>
                                                <Box height="10px" width="10px" sx={{ backgroundColor: '#07bc0c', padding: '6px' }}>
                                                </Box>
                                                <Typography style={{ fontSize: "12px", fontWeight: "600" }}>Verified By: {row?.verifiedUser ?? "N/A"}</Typography>
                                            </Box>
                                        </Box>
                                    } placement="bottom" arrow key={index}>
                                        <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}  >
                                            <TableCell style={{ fontSize: "12px" }}>{skip > 0 ? skip * take + index + 1 : ++index}</TableCell>
                                            <TableCell align="left" style={{ fontSize: "12px" }}>{row.lockerNumber}</TableCell>
                                            <TableCell align="left" style={{ fontSize: "12px" }}>{row.lockerType}</TableCell>
                                            <TableCell align="left" style={{ fontSize: "12px" }}>{row.branchName}</TableCell>
                                            <TableCell align="left" style={{ fontSize: "12px" }}>{row.locationName}</TableCell>
                                            <TableCell align="left" style={{ fontSize: "12px" }}>
                                                {row.isApproved ? "Yes" : "No"}
                                            </TableCell>
                                            <TableCell align="left">
                                                <Chip style={{ backgroundColor: getStatusColor(row.status), color: 'white', fontSize: "12px" }} label={row.lockerStatus} />
                                            </TableCell>

                                        </TableRow>
                                    </Tooltip>
                                ))}
                    </TableBody>
                </Table>
            </TableContainer>
            {lockerList && (lockerList?.length > 0 || !loading) ? <TablePagination count={count} skip={skip} setSkip={setSkip} take={take} setTake={setTake} /> : null}
        </Paper>


    </Box>
    );
}
